import './email-list-control.scss';

import EmailListControl from './EmailListControl';

export default EmailListControl;
